// src/pages/admin/workspace/useWorkspaceTheme.js
//
// Light/Dark preference for the Dashboard Selector ONLY. The value is applied as
// a data attribute on the workspace root element by the caller; this hook never
// touches document, <html> or <body>. Only the non-sensitive string "light" or
// "dark" is stored.
import { useCallback, useState } from "react";

export const WORKSPACE_THEME_STORAGE_KEY = "campusConnect.dashboardSelector.theme";

const readTheme = () => {
  try {
    return window.localStorage.getItem(WORKSPACE_THEME_STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

const writeTheme = (theme) => {
  try {
    window.localStorage.setItem(WORKSPACE_THEME_STORAGE_KEY, theme);
  } catch {
    /* preference only — ignore quota / privacy-mode errors */
  }
};

export default function useWorkspaceTheme() {
  // Read synchronously on first render so the saved theme is painted at once.
  const [theme, setTheme] = useState(readTheme);

  const toggleTheme = useCallback(() => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    writeTheme(next);
  }, [theme]);

  return { theme, toggleTheme };
}
